import { Landing } from '@ofself/shell'
import { qh } from './qh.js'

/* THE DOOR IS THE KIT'S LANDING (owner call 2026-09-19: "the prelogin landing
   page needs to follow the shell level template — see other apps"). Every
   ecosystem front door shares one anatomy — the bare field, the app's mark
   drawing itself, the wordmark top-left, the tagline bottom-right, the
   sign-in pill as the one action — and this mounts it as ink mounts its own:
   rail-less, no mark passed (the register draws the dictionary's figure for
   currentApp, the same figure the rail, the splash and the tab wear), no
   title (the mark and the wordmark say the name). The strings are the
   dictionary's; the anatomy is the shell's. */
export default function Door() {
  return <Landing currentApp="dictionary" rail={false} authorizeUrl="/auth/connect"
    wordmark="DICTIONARY"
    bottomRight={<span {...qh('dictionary.oS', 'A dictionary in your terms: the words you actually use, defined once, and reused everywhere else you think.')}>A dictionary in your terms.</span>}
    download={{ href: '/download/dictionary.dmg' }} />
}
